/*
 * humo-recently-viewed.js — Humo Commerce
 * «Вы смотрели» (sections/humo-recently-viewed.liquid): читает cookie shopify_recently_viewed
 * и подгружает карточки humo-product-card через Section Rendering API:
 *   /products/<handle>?section_id=humo-recently-viewed-item
 *
 * Cookie пишет вендорный Shopify.RecordViewedProducts (theme.js): handles через пробел,
 * свежий — первым. На новой странице товара его вызывает humo-product.js.
 *
 * Контракт с разметкой секции:
 *   [data-humo-rv]          — корень; data-limit, data-current-handle, data-choose-label, data-one-click
 *   [data-humo-rv-grid]     — сетка, сюда добавляются <li data-humo-rv-item>
 *   [data-humo-rv-note]     — подсказка в редакторе темы, убираем при появлении карточек
 *
 * «В корзину»: vendor ajaxCart.init() вешает обработчики только при загрузке страницы,
 * карточки приходят позже — привязываем новые кнопки сами, как humo-collection.js.
 * Удалённый или скрытый товар (404) пропускаем и берём следующий из списка.
 *
 * Отладка: ?humo_debug=1 в адресе включает логи [FIX:recently-viewed] в консоли.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'shopify_recently_viewed';
  var ITEM_SECTION = 'humo-recently-viewed-item';
  var DEBUG = /[?&]humo_debug=1(&|$)/.test(window.location.search);

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[FIX:recently-viewed]'].concat([].slice.call(arguments)));
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(value);
    } catch (error) {
      return value;
    }
  }

  // Значение js-cookie: encodeURIComponent от строки «handle handle …»
  function readHandles() {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf('=');
      if (eq === -1 || parts[i].slice(0, eq) !== COOKIE_NAME) continue;
      return safeDecode(parts[i].slice(eq + 1)).split(' ').filter(Boolean);
    }
    return [];
  }

  function itemUrl(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '?section_id=' + ITEM_SECTION;
  }

  // Карточка одного товара или null (404, пустой ответ, сеть)
  function fetchItem(handle) {
    return fetch(itemUrl(handle), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          if (response.status === 404) {
            log('skip, product not found', handle);
          } else {
            console.warn('[humo-recently-viewed] HTTP ' + response.status + ' for', handle);
          }
          return null;
        }
        return response.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var item = doc.querySelector('[data-humo-rv-item]');
          if (!item) log('skip, empty section response', handle);
          return item ? document.importNode(item, true) : null;
        });
      })
      .catch(function (error) {
        console.warn('[humo-recently-viewed] request failed for', handle, error);
        return null;
      });
  }

  // Подпись «Выбрать» и «в один клик» — из настроек секции на странице.
  // «Узнать цену» (товар с ценой по запросу, data-price-request) не трогаем: это её единственная кнопка
  function adaptItem(item, section) {
    var chooseLabel = section.getAttribute('data-choose-label');
    var chooseLink = item.querySelector('a.humo-card__add:not([data-price-request]) > span');
    if (chooseLabel && chooseLink) chooseLink.textContent = chooseLabel;

    if (section.getAttribute('data-one-click') !== 'true') {
      var oneClick = item.querySelector('.js-humo-one-click-open:not([data-price-request])');
      if (oneClick) oneClick.parentNode.removeChild(oneClick);
    }
  }

  function bindCart(container) {
    if (!window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart) {
      console.warn('[humo-recently-viewed] Shopify.theme.ajaxCart not found, add to cart is not bound');
      return;
    }
    var configEl = document.getElementById('cart-config');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.innerHTML || '{}');
    } catch (error) {
      console.error('[humo-recently-viewed] invalid #cart-config JSON', error);
      return;
    }

    container.querySelectorAll('.js-ajax-submit:not([data-humo-bound])').forEach(function (button) {
      button.setAttribute('data-humo-bound', '');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        Shopify.theme.ajaxCart.addToCart(
          button.closest('form'),
          button.parentNode,
          config,
          false,
          button.hasAttribute('data-quick-add')
        );
      });
    });
  }

  function init(section) {
    if (!section || section.hasAttribute('data-humo-rv-ready')) return;
    section.setAttribute('data-humo-rv-ready', '');

    var grid = section.querySelector('[data-humo-rv-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-limit'), 10) || 5;
    var current = section.getAttribute('data-current-handle') || '';
    var queue = readHandles().filter(function (handle) {
      return handle !== current;
    });
    log('handles', queue, 'current', current, 'limit', limit);
    if (!queue.length) return;

    var shown = 0;

    // Берём недостающее количество из очереди параллельно; порядок cookie сохраняем
    function loadNext() {
      var batch = queue.splice(0, limit - shown);
      if (!batch.length) return Promise.resolve();
      return Promise.all(batch.map(fetchItem)).then(function (items) {
        var fragment = document.createDocumentFragment();
        items.forEach(function (item) {
          if (!item || shown >= limit) return;
          adaptItem(item, section);
          fragment.appendChild(item);
          shown++;
        });
        grid.appendChild(fragment);
        if (shown < limit && queue.length) return loadNext();
      });
    }

    loadNext().then(function () {
      log('shown', shown);
      if (!shown) return;
      bindCart(grid);
      var note = section.querySelector('[data-humo-rv-note]');
      if (note) note.parentNode.removeChild(note);
      section.hidden = false;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-humo-rv]').forEach(init);
  }

  // После DOMContentLoaded: theme.js (defer, ниже по документу) уже выполнен, vendor ajaxCart.init()
  // привязал свои кнопки и не задвоит обработчик на наших. Во время defer-скриптов readyState
  // уже 'interactive', поэтому сразу запускаем только при 'complete'.
  if (document.readyState === 'complete') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-humo-rv]'));
  });
})();
